import { FC, memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Flex } from '@rebass/emotion';

import messages from './PaymentOption.messages';
import { Label, Logo } from './PaymentOption.styles';

import sepaLogo from './sepa.svg';
import paypalLogo from './paypal.svg';
import paypalCreditLogo from './paypalCredit.svg';
import visaLogo from './visa.svg';
import mastercardLogo from './mastercard.svg';
import amexLogo from './amex.svg';
import sofortLogo from './sofort.svg';
import jcbLogo from './jcb.svg';
import dinersClubLogo from './dinersClub.svg';
import klarnaLogo from './klarna.svg';
import cashOnDeliveryLogo from './cashOnDelivery.svg';

const PaymentOption: FC<PaymentOptionProps> = ({ code, title }) => {
  const logos: string[] = getLogosForCode(code);

  return (
    <Flex alignItems="center" justifyContent="space-between" flex={1}>
      <Label>{title}</Label>
      <Flex alignItems="center">
        {logos.map((logo) => (
          <Logo key={logo} src={logo} />
        ))}
        {/stripe_payments$/i.test(code) ? (
          <Box ml={2}>
            <FormattedMessage {...messages.paymentMethodMoreIndicator} />
          </Box>
        ) : null}
      </Flex>
    </Flex>
  );
};
export default memo(PaymentOption);

interface PaymentOptionProps {
  code: string;
  title: string;
}

const getLogosForCode = (code: string) => {
  if (/bankpayment/i.test(code)) return [sepaLogo];
  if (/banktransfer/i.test(code)) return [sepaLogo];
  if (/paypal_express_bml/i.test(code)) return [paypalCreditLogo];
  if (/paypal_credit/i.test(code)) return [paypalCreditLogo];
  if (/paypal/i.test(code)) return [paypalLogo];
  if (/visa/i.test(code)) return [visaLogo];
  if (/mastercard/i.test(code)) return [mastercardLogo];
  if (/amex/i.test(code)) return [amexLogo];
  if (/sofort/i.test(code)) return [sofortLogo];
  if (/jcb/i.test(code)) return [jcbLogo];
  if (/diners/i.test(code)) return [dinersClubLogo];
  if (/klarna/i.test(code)) return [klarnaLogo];
  if (/cashondelivery/i.test(code)) return [cashOnDeliveryLogo];
  if (/stripe/i.test(code)) return [visaLogo, mastercardLogo, dinersClubLogo];

  return [];
};
